<div class="support-chat">
    <!-- Floating Support Button -->
    <button class="support-btn" (click)="onSupportClick()">
        <img src="assets/images/zoom_help.png" alt="Zoom help"/>
    </button>

    <!-- Desktop Popup -->
    <div class="support-popup" *ngIf="showPopup">
        <div class="popup-content">
            <h4 class="heading">Do you need help?</h4>
            <p class="mb-0">Call us at:</p>
            <div>
                <h6 class="phone-link">
                    {{ phone }}
                </h6>
            </div>
            <button class="close-btn w-100" (click)="closeSupportPopup()">Close</button>
        </div>
    </div>
</div>